import { render, staticRenderFns } from "./ProjectVideoListDialogItem.vue?vue&type=template&id=5a02e45e&scoped=true&"
import script from "./ProjectVideoListDialogItem.vue?vue&type=script&lang=js&"
export * from "./ProjectVideoListDialogItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVideoListDialogItem.vue?vue&type=style&index=0&id=5a02e45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02e45e",
  null
  
)

export default component.exports